import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './ResetPasswordPage.css';

function ResetPasswordPage() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: ''
    });
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            setErrorMessage('Parooli lähtestamise tunnus on vigane või puudub. Küsi uus lähtestamislink.');
        }
    }, [token]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        setMessage('');

        if (formData.newPassword !== formData.confirmPassword) {
            setErrorMessage('Paroolid ei kattu.');
            return;
        }

        if (formData.newPassword !== formData.newPassword.trim()) {
            setErrorMessage('Parool ei tohi alata ega lõppeda tühikuga.');
            return;
        }

        if (formData.newPassword.length < 6) {
            setErrorMessage('Parool peab olema vähemalt 6 tähemärki pikk.');
            return;
        }

        if (!token) {
            setErrorMessage('Parooli lähtestamise tunnus on vigane või puudub.');
            return;
        }

        setIsLoading(true);

        try {
            await axiosInstance.post('/api/public/reset-password', {
                token: token,
                newPassword: formData.newPassword
            });
            setMessage('Parool on lähtestatud. Suunamine sisselogimise lehele...');
            setTimeout(() => {
                navigate('/login');
            }, 2000);
        } catch (error) {
            const errorMsg = error.response?.data?.message || error.response?.data || "Ilmnes viga. Proovi uuesti.";
            setErrorMessage(errorMsg);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="reset-password-container">
            <div className="reset-password-box">
                <h2>Lähtesta parool</h2>
                <form onSubmit={handleSubmit} className="reset-password-form">
                    <div className="form-group">
                        <label>Uus parool</label>
                        <input 
                            type="password"
                            id="newPassword"
                            name="newPassword"
                            placeholder="Sisesta uus parool"
                            value={formData.newPassword}
                            onChange={handleChange}
                            required
                            autoComplete="new-password"
                            minLength={6}
                        />
                    </div>
                    <div className="form-group">
                        <label>Kinnita parool</label>
                        <input 
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Kinnita uus parool"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                            autoComplete="new-password"
                            minLength={6}
                        />
                    </div>
                    <button type="submit" disabled={isLoading || !token}>
                        {isLoading ? 'Lähtestamine...' : 'Lähtesta parool'}
                    </button>
                    {message && (
                        <p className="success-message">
                            {message}
                        </p>
                    )}
                    {errorMessage && (
                        <p className="error-message">
                            {errorMessage}
                        </p>
                    )}
                    <div className="back-to-login-link">
                        <a href="/login">
                        Tagasi sisselogimise juurde
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ResetPasswordPage;

